import { SideBar } from '../common/sideBar'
import { COMPONENTS } from '../routers/constants'
import './lang/i18n'

export const SIDE_BAR_SCROLL_ID = 'SIDE_BAR_SCROLL_ID'

const SideBarUserManagement = ({
  renderTopComponent,
  renderBottomComponent,
  isLoadingContent,
}) => {
  const NAVIGATION_LIST = [
    {
      route: COMPONENTS.userManagement.components.userProfile.route,
      label: 'userProfile.USER_PROFILE',
    },
    {
      route: COMPONENTS.userManagement.components.settingsPreferences.route,
      label: 'settingPreferences.TITLE',
    },
    {
      route: COMPONENTS.userManagement.components.subscriptionPayment.route,
      label: 'subscriptionPayment.TITLE',
    },
    // comment history Feature because BE undeveloped feature
    // {
    //   route: COMPONENTS.userManagement.components.engagementHistory.route,
    //   label: 'engagementHistory.TITLE',
    // },
  ]

  return (
    <SideBar
      list={NAVIGATION_LIST}
      isResponsive={false}
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={isLoadingContent}
      isShowFooter={false}
      scrollId={SIDE_BAR_SCROLL_ID}
    />
  )
}

export default SideBarUserManagement
